import { UiRouterTitleService } from './ui.router-title.service';
import { IDirective } from 'angular';

export function uiRouterTitleDirective( uiRouterTitleService: UiRouterTitleService ): IDirective {
  return {
    restrict: 'A',
    link: function postLink( scope, element ) {
      const sub = uiRouterTitleService.getTitle()
        .subscribe(( title ) => element.text(title));
      scope.$on('$destroy', () => sub.unsubscribe());
    }
  };
}

uiRouterTitleDirective.$inject = [
  'UiRouterTitleService'
];



// WEBPACK FOOTER //
// ./app/shared/directives/ui-router-title/ui-router-title.directive.ts